import { render, staticRenderFns } from "./sidebar-box.vue?vue&type=template&id=e063def4&scoped=true&"
import script from "./sidebar-box.vue?vue&type=script&lang=js&"
export * from "./sidebar-box.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-box.vue?vue&type=style&index=0&id=e063def4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e063def4",
  null
  
)

export default component.exports